import { render, staticRenderFns } from "./TeacherPageCreateForm.vue?vue&type=template&id=2e3e72e6&scoped=true&"
import script from "./TeacherPageCreateForm.vue?vue&type=script&lang=js&"
export * from "./TeacherPageCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e72e6",
  null
  
)

export default component.exports